exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#profile-page-container{width:100%;padding:20px;margin-top:100px;background-color:#fff}#profile-page-container #profile-pic{border-radius:50%;transform:translateY(-60%);margin:0 auto;width:200px;height:200px;background-color:#fff}#profile-page-container #profile-pic #profile-pic-img{width:calc(100% - 10px);position:absolute;height:calc(100% - 10px);margin-top:5px;margin-left:5px;border-radius:50%}#profile-page-container .profile-page-content{margin-top:-50px;margin-bottom:50px}#profile-page-container .profile-page-content .row{padding-top:5px;padding-bottom:5px}#profile-page-container .profile-page-content .user-info{padding:15px}#profile-page-container .profile-page-content .user-info .highlighted{background-color:#bee0ea73}#profile-page-container .profile-page-content .user-permits{padding:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/settings/general/userProfile.scss
// module id = 2164
// module chunks = 43